@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

.label-card {
  height: 50px;
  background: @label-card--background-color;
  display: flex;
  border-top: 1px solid @label-card--border-color;
  border-bottom: 1px solid @label-card--border-color;

  &.purchased {
    background: @label-card--purchased--background-color;
  }

  &.marked-complete {
    background: @label-card--complete--background-color;
  }

  &.voided {
    opacity: 0.5;
    background-color: @label-card--voided--background-color;

    .tracking-number,
    .service-name {
      color: @label-card--text-color;
      text-decoration: line-through;
      cursor: default;
    }
  }
}

.tracking-and-service-section {
  display: flex;
  padding-left: 10px;
  justify-content: center;
  flex-direction: column;
}

.carrier-logo {
  height: 100%;
  padding: 8px;
  width: 50px;
  min-width: 50px;
  background: @label-card--carrier-logo--background-color;

  &.not-purchased {
    opacity: 0.5;
  }

  &.voided {
    filter: grayscale(100%);
  }
}

.tracking-number-section {
  width: 100%;
  display: flex;
}

.tracking-number {
  display: flex;
  align-items: center;
  font-size: 16px;
  line-height: 20px;
}

.service-name {
  font-size: 12px;
  color: @label-card--service-name--text-color;

  &.not-purchased {
    font-size: 16px;
    color: @label-card--service-name-not-purchased--text-color;
  }
}

.children-section {
  align-self: center;
  padding: 10px;
  display: flex;
  justify-content: flex-end;
  text-align: left;
  margin-left: auto;
  color: @label-card--children-section--text-color;

  &.has-message {
    text-align: right;
    align-self: flex-start;
  }
}

.warning-icon {
  fill: @label-card--icon--warning--fill-color;
  padding: 5px;
}

.tracking-icon-container {
  display: flex;
  height: 20px;
  width: 20px;
  position: relative;
  margin-right: 3px;
}

.trackingIconMixin() {
  height: 30px;
  width: 30px;
  top: -5px;
  left: -5px;
  min-width: 30px;
  position: absolute;
}

.tracking-icon-unknown {
  .trackingIconMixin();
  padding: 7px;
}

.tracking-icon-shipped {
  .trackingIconMixin();
  padding: 3px;
}

.tracking-icon-delivered {
  .trackingIconMixin();
  padding: 9px;
}

.tracking-icon-error {
  .trackingIconMixin();
  padding: 6px;
}

.message-text {
  font-size: 12px;
  width: 100%;
  padding-left: 5px;
  text-align: right;
  line-height: 20px;
  color: @label-card--message-text--text-color;

  &.warning {
    color: @label-card--message-text--warning--text-color;
    text-align: left;
    display: flex;
    align-items: center;
  }
}
